export default ({
  first_name = null,
  last_name = null,
  email = null,
  phone_number = null,
  country = null,
  country_code = null,
}) => ({
  first_name,
  last_name,
  email,
  phone_number,
  country,
  country_code,
});
